module.exports = __webpack_public_path__ + "static/media/insect(28).64b26d6c.PNG";